import React, { useEffect } from 'react';

import LoadingAnimation from 'components/loading-animation';

import { IPayPalButton } from './types';
import { useBraintree } from './use-braintree.web';

const PayPalButton: React.FC<IPayPalButton> = ({
  serverOrder,
  onResult,
  onError,
  showLoading,
}: IPayPalButton) => {
  const { isLoading, loadPayPalButton } = useBraintree({
    onResult,
    onError,
  });

  useEffect(() => {
    if (serverOrder?.cart) {
      const totalCents = serverOrder?.cart.totalCents;
      loadPayPalButton({ amount: totalCents / 100, selector: '#paypal-button' });
    }
  }, [serverOrder?.cart]);

  return (
    <>
      {isLoading || showLoading ? <LoadingAnimation /> : null}
      <div
        id="paypal-button"
        style={{ visibility: isLoading || showLoading ? 'hidden' : 'visible', width: '100%' }}
      ></div>
    </>
  );
};

export default PayPalButton;
